import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '../../../../../../components/mui/Core/index'
import Constants from '../../../../../../constants/en.json'
import { setIsInviteConfirmed } from '../../invite-user-modal-slice'

function SendInvite() {
  const dispatch = useDispatch()
  const userEmail = useSelector((state) => state.inviteUser.email)
  const selectedRole = useSelector((state) => state.inviteUser.selectedRole)
  const isInviteConfirmed = useSelector((state) => state.inviteUser.isInviteConfirmed)
  const selectedOrganization = useSelector((state) => state.inviteUser.selectedOrganization)
  const selectedOrganizationName =
    selectedOrganization?.clientShortName || selectedOrganization?.customerName

  const handleChangeConfirmInvite = () => {
    dispatch(setIsInviteConfirmed())
  }

  const rootStyle = { minHeight: '257px' }
  const confirmMessageContainerStyle = { marginTop: '20px' }
  const emailContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  }
  const roleContainerStyle = { display: 'flex', justifyContent: 'space-between', marginTop: '12px' }
  const organizationContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '12px',
  }
  const confirmInviteContainerSyle = { marginTop: '12px' }
  const confirmInviteRadioButtonSyle = { padding: 0 }

  return (
    <Box sx={rootStyle}>
      <Box>
        <Typography variant='cardHeader'>
          {Constants.userManagement.inviteUser.CONFIRM_INVITE_INFO}
        </Typography>
        <Box sx={confirmMessageContainerStyle}>
          <Typography>{Constants.userManagement.inviteUser.CONFIRM_INVITE_MESSAGE}</Typography>
        </Box>
        <Box sx={emailContainerStyle}>
          <Box>
            <Typography>{Constants.userManagement.inviteUser.USER_EMAIL}:</Typography>
          </Box>
          <Box>
            <Typography>{userEmail}</Typography>
          </Box>
        </Box>
        <Box sx={roleContainerStyle}>
          <Box>
            <Typography>{Constants.userManagement.inviteUser.USER_ROLE}:</Typography>
          </Box>
          <Box>
            <Typography>{selectedRole?.roleDescription}</Typography>
          </Box>
        </Box>
        <Box sx={organizationContainerStyle}>
          <Box>
            <Typography>{Constants.userManagement.inviteUser.USER_ORGANIZATION}:</Typography>
          </Box>
          <Box>
            <Typography>{selectedOrganizationName}</Typography>
          </Box>
        </Box>
        <Box sx={confirmInviteContainerSyle}>
          <FormControl>
            <RadioGroup name='confirm-invite-radio-button-group'>
              <FormControlLabel
                checked={isInviteConfirmed}
                value
                sx={confirmInviteRadioButtonSyle}
                control={<Radio />}
                label={Constants.userManagement.inviteUser.I_HAVE_CONFIRMED_MESSAGE}
                variant='outlined'
                onChange={handleChangeConfirmInvite}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}

export default SendInvite
